import Box from "@mui/material/Box";
import UserPage from "./UserInfo";
import ChangePassword from "./ChangePassword";
import TwoFactorSettings from "../twoFactor/TwoFactorSettings";

export function ProfileSettings() {
  return (
    <Box sx={{ p: 3, bgcolor: "background.paper" }}>
      <UserPage />
    </Box>
  );
}

export function SecuritySettings() {
  return (
    <Box sx={{ p: 3, bgcolor: "background.paper" }}>
      <ChangePassword />
      <TwoFactorSettings />
    </Box>
  );
}
